

    if (window.Sentry) {
      window.Sentry.init({ dsn: "https://5c70d1623f10432da8b4b6562ee0599b@sentry.wixpress.com/463", environment: 'Editor' });
    }
  

    import React from 'react';
    import ReactDOM from 'react-dom';
    import { withStyles } from '@wix/native-components-infra';
    import EditorAppWrapper from '@wix/yoshi-flow-editor/runtime/esm/EditorAppWrapper.js';
    import Widget from '/home/builduser/agent00/work/373821cf82c7c4b7/subscriptions/subscriptions-tpa/src/components/MySubscriptions/Widget/index.tsx';
    import createController from '/home/builduser/agent00/work/373821cf82c7c4b7/subscriptions/subscriptions-tpa/src/components/MySubscriptions/controller.ts';

    
import { createHttpClient } from '@wix/yoshi-flow-editor/runtime/esm/controller/httpClientProp';
    

    

  import { initI18nWithoutICU as initI18n } from '@wix/yoshi-flow-editor/runtime/esm/i18next/init';


    
import { createExperiments, createWidgetExperiments } from '@wix/yoshi-flow-editor/runtime/esm/experiments';
    

    

    var createErrorMonitor = null;
    

    
import { I18nextProvider } from '@wix/yoshi-flow-editor/i18n';


      import { PureExperimentsProvider } from '@wix/yoshi-flow-editor';
      var ExperimentsProvider = React.Fragment;
      

import { BILoggerProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/BILogger/BILoggerProvider';

import { FedopsLoggerProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/FedopsLoggerProvider';

import { HttpProvider } from '@wix/yoshi-flow-editor';

var BaseUiEnvironmentProviderWrapper = React.Fragment;

var providers = {
  I18nextProvider,
  ExperimentsProvider,
  PureExperimentsProvider,
  BILoggerProvider,
  FedopsLoggerProvider,
  HttpProvider,
  BaseUiEnvironmentProviderWrapper,
}

    import * as fedopsLogger from '@wix/yoshi-flow-editor/fedops';

    
  var importedApp = {};

    var componentName = 'MySubscriptions';
    var projectName = 'subscriptions-tpa';
    var sentryConfig = {
      DSN: 'https://5c70d1623f10432da8b4b6562ee0599b@sentry.wixpress.com/463',
      id: '5c70d1623f10432da8b4b6562ee0599b',
      projectName: 'subscriptions-tpa',
      teamName: 'pricing-plans',
      
    };
    import stylesParams from '/home/builduser/agent00/work/373821cf82c7c4b7/subscriptions/subscriptions-tpa/src/components/MySubscriptions/stylesParams.ts';
    var experimentsConfig = {"centralized":true,"scopes":["subscriptions-tpa"]};
    var fedopsConfig = null;
    var translationsConfig = {"icuEnabled":false,"defaultTranslationsPath":"/home/builduser/agent00/work/373821cf82c7c4b7/subscriptions/subscriptions-tpa/src/assets/locales/messages_en.json","availableLanguages":["ar","bg","ca","cs","da","de","el","en","es","fi","fr","he","hi","hu","id","it","ja","ko","lt","ms","nl","no","pl","pt","ro","ru","sk","sl","sv","th","tl","tr","uk","vi","zh"]};
    var defaultTranslations = {"app.widget.welcome":"Welcome","app.settings.main-tab":"Main","app.settings.main-tab.content":"Members can view and manage any subscriptions they’ve purchased here.","app.settings.main-tab.customize-cta":"Customize","app.settings.design-tab":"Design","app.settings.text-and-link-style":"Text & Link Style","app.settings.page-header":"Page Header","app.settings.page-title":"Page title","app.settings.page-subtitle":"Page subtitle","app.settings.content":"Content","app.settings.content-with-subscriptions":"With Subscriptions","app.settings.subscription-name":"Subscription name","app.settings.subscription-info":"Subscription info","app.settings.content-without-subscriptions":"Without Subscriptions","app.settings.no-subscription-message":"No subscription message","app.settings.link-style":"Link Style","app.settings.link":"Link","app.settings.background-and-dividers":"Background & Dividers","app.settings.background":"Background","app.settings.background-color":"Background color","app.settings.background-border-width":"Background border width","app.settings.background-border-color":"Background border color","app.settings.divider":"Divider","app.settings.divider-color":"Divider color","app.settings.divider-width":"Divider width","app.settings.text-tab":"Text","app.settings.description":"Description","app.settings.cancel-plan-text":"Cancel subscription text","app.settings.buy-new-plan-text":"Buy new subscription text","app.settings.back":"Back","app.settings.choose-your-font":"Choose your font","app.settings.pp-link-text":"Pricing Plans link text","app.settings.default-page-title-text":"My Subscriptions","app.settings.default-page-description-text":"View and manage the subscriptions you've purchased","app.settings.default-no-subscription-text":"You haven't purchased any subscriptions yet.","app.settings.default-buy-new-plan-text":"Buy New Subscription","app.settings.default-cancel-subscription-text":"Cancel Subscription","app.settings.default-pricing-plans-text":"View Plans & Pricing","app.settings.default-stores-link-text":"Go to Shop","app.subscription-status.free-trial":"Free Trial","app.subscription-status.undefined":"Undefined","app.subscription-status.draft":"Draft","app.subscription-status.pending":"Pending","app.subscription-status.active":"Active","app.subscription-status.expired":"Expired","app.subscription-status.canceled":"Canceled","app.subscription-status.pending-cancellation":"Pending Cancellation","app.subscription-status.suspended":"Suspended","app.title.starts":"Starts: {{ date }}","app.title.expires":"Expires: {{ date }}","app.title.valid-until-canceled":"Valid until canceled","app.title.expired":"Expired: {{ date }}","app.title.canceled":"Canceled: {{ date }}","app.details.expires":"Expires: {{ date }}","app.details.price-per-day":"{{ price }} per day","app.details.price-per-week":"{{ price }} per week","app.details.price-per-month":"{{ price }} per month","app.details.price-per-year":"{{ price }} per year","app.details.price-undefined":"{{ price }}","app.details.payments-completed-of-total":"Payments completed: {{ totalSuccessfulPayments }} of {{ totalBillingCycles }}","app.details.payments-completed":"Payments completed: {{ totalSuccessfulPayments }}","app.details.last-payment":"Last payment: {{ date }}","app.details.next-payment":"Next payment: {{ date }}","app.details.payment-method-credit-card":"Credit card","app.details.payment-method-paypal":"Paypal","app.details.payment-method-offline":"Offline payment","app.details.valid-until-canceled":"Valid until canceled","app.details.start-date":"Start date: {{ date }}","app.details.trial-ends":"Trial ends: {{ date }}","app.details.free-plan":"Free Plan","app.details.sessions-remaining":"Sessions remaining: {{ remainingCredits }} of {{ totalCredits }}","app.details.sessions-remaining-without-total":"Sessions remaining: {{ remainingCredits }}","app.details.quantity":"Qty: {{ quantity }}","app.details.shipping-to":"Shipping to:","app.cancel-confirm-modal.close":"Close","app.cancel-confirm-modal.title":"Cancel {{ subscriptionName }}?","app.cancel-confirm-modal.description":"If canceled, you won’t have access to this plan and its benefits from now on.","app.cancel-confirm-modal.description-recurring":"If canceled, you won’t have access to this plan and its benefits after the current billing cycle ends.","app.cancel-confirm-modal.cancel":"Keep It","app.cancel-confirm-modal.confirm":"Yes, Cancel"};
    var biConfig = null;
    var appDefinitionId = "2bef2abe-7abe-43da-889c-53c1500a328c";
    var componentId = "b29db04a-a8f2-4bfe-bbad-21c99c1054b5";
    var localeDistPath = 'assets/locales';
    var shouldUseEssentials = true;
    var shouldSkipMultipleRendersAfterViewModeChange = false;
    var withErrorBoundary = false;

    import { createVisitorBILogger as biLogger } from '/home/builduser/agent00/work/373821cf82c7c4b7/subscriptions/subscriptions-tpa/target/generated/bi/createBILogger.ts';
    
      import { hot } from '@wix/component-hot-loader';
      var UserComponent = hot(module, Widget);
    

    var EditorComponent = React.createElement(EditorAppWrapper, {
      UserComponent,
      appDefinitionId,
      componentId,
      name: componentName,
      sentryConfig: sentryConfig,
      experimentsConfig: experimentsConfig,
      fedopsConfig: fedopsConfig,
      translationsConfig: translationsConfig,
      defaultTranslations: defaultTranslations,
      shouldUseEssentials,
      projectName: projectName,
      biConfig: biConfig,
      biLogger: biLogger,
      stylesParams,
      withErrorBoundary,
      shouldSkipMultipleRendersAfterViewModeChange,
      userController: createController,
      customInitAppForPage: importedApp.initAppForPage,
      optionalDeps: {
        initI18n,
        fedopsLogger,
        withStylesHoc: withStyles,
        createHttpClient,
        createExperiments,
        createWidgetExperiments,
        createErrorMonitor,
        providers,
      },
      localeDistPath: localeDistPath,
    });
    ReactDOM.render(EditorComponent, document.getElementById('root'));
